import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable, of, throwError} from "rxjs";
import {catchError, map, retry} from "rxjs/operators";
import {FormulaConfig} from "../_models/formula-config";
import {WpdForm} from "../_models/wpd-form";
import {environment} from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    private Token = '5F2274F5-37AE-4663-BF0F-1B40644A4A1A'; // 未知來源？

    constructor(private http: HttpClient) {
    }

    getFormulaConfigs() {
        return this.http.post<ApiResponse<FormulaConfig>>(environment.api_url,
            {},
            {
                headers: {
                    KeyId: environment.key.getFormulaConfigs,
                    Token: this.Token,
                },
            })
            .pipe(
                map(x => x.ReturnResult)
            );
        // const data:FormulaConfig = {
        //     "ageMort": [
        //         {
        //             "retireAge": 60,
        //             "lifetime": 24
        //         },
        //         {
        //             "retireAge": 61,
        //             "lifetime": 24
        //         },
        //         {
        //             "retireAge": 62,
        //             "lifetime": 23
        //         },
        //         {
        //             "retireAge": 63,
        //             "lifetime": 22
        //         },
        //         {
        //             "retireAge": 64,
        //             "lifetime": 21
        //         },
        //         {
        //             "retireAge": 65,
        //             "lifetime": 20
        //         },
        //         {
        //             "retireAge": 66,
        //             "lifetime": 20
        //         },
        //         {
        //             "retireAge": 67,
        //             "lifetime": 19
        //         },
        //         {
        //             "retireAge": 68,
        //             "lifetime": 18
        //         },
        //         {
        //             "retireAge": 69,
        //             "lifetime": 17
        //         },
        //         {
        //             "retireAge": 70,
        //             "lifetime": 17
        //         },
        //         {
        //             "retireAge": 71,
        //             "lifetime": 16
        //         },
        //         {
        //             "retireAge": 72,
        //             "lifetime": 15
        //         },
        //         {
        //             "retireAge": 73,
        //             "lifetime": 14
        //         },
        //         {
        //             "retireAge": 74,
        //             "lifetime": 14
        //         },
        //         {
        //             "retireAge": 75,
        //             "lifetime": 13
        //         },
        //         {
        //             "retireAge": 76,
        //             "lifetime": 12
        //         },
        //         {
        //             "retireAge": 77,
        //             "lifetime": 12
        //         },
        //         {
        //             "retireAge": 78,
        //             "lifetime": 11
        //         },
        //         {
        //             "retireAge": 79,
        //             "lifetime": 10
        //         },
        //         {
        //             "retireAge": 80,
        //             "lifetime": 10
        //         },
        //         {
        //             "retireAge": 81,
        //             "lifetime": 9
        //         },
        //         {
        //             "retireAge": 82,
        //             "lifetime": 9
        //         },
        //         {
        //             "retireAge": 83,
        //             "lifetime": 8
        //         },
        //         {
        //             "retireAge": 84,
        //             "lifetime": 8
        //         },
        //         {
        //             "retireAge": 85,
        //             "lifetime": 7
        //         }
        //     ],
        //     "salaryRise": [
        //         {
        //             "code": "a",
        //             "name": "農、林、漁、牧業",
        //             "rate": 0.34333
        //         },
        //         {
        //             "code": "b",
        //             "name": "礦業及土石採取業",
        //             "rate": 0.34333
        //         },
        //         {
        //             "code": "c",
        //             "name": "製造業",
        //             "rate": 2.32333
        //         },
        //         {
        //             "code": "d",
        //             "name": "電力及燃氣供應業",
        //             "rate": 0.01
        //         },
        //         {
        //             "code": "e",
        //             "name": "用水供應及污染整治業",
        //             "rate": 0.92333
        //         },
        //         {
        //             "code": "f",
        //             "name": "營建工程業",
        //             "rate": 0.78
        //         },
        //         {
        //             "code": "g",
        //             "name": "批發及零售業",
        //             "rate": 2.71333
        //         },
        //         {
        //             "code": "h",
        //             "name": "運輸及倉儲業",
        //             "rate": 2.33667
        //         },
        //         {
        //             "code": "i",
        //             "name": "住宿及餐飲業",
        //             "rate": 2.68333
        //         },
        //         {
        //             "code": "j",
        //             "name": "出版、影音製作、傳播及資通訊服務業",
        //             "rate": 2.65333
        //         },
        //         {
        //             "code": "k",
        //             "name": "金融及保險業",
        //             "rate": 1.53667
        //         },
        //         {
        //             "code": "l",
        //             "name": "不動產業",
        //             "rate": 4.64
        //         },
        //         {
        //             "code": "m",
        //             "name": "專業、科學及技術服務業",
        //             "rate": 2.67667
        //         },
        //         {
        //             "code": "n",
        //             "name": "支援服務業",
        //             "rate": 2.02
        //         },
        //         {
        //             "code": "o",
        //             "name": "公共行政及國防；強制性社會安全",
        //             "rate": 1.53667
        //         },
        //         {
        //             "code": "p",
        //             "name": "教育業",
        //             "rate": 5.87
        //         },
        //         {
        //             "code": "q",
        //             "name": "醫療保健及社會工作服務業",
        //             "rate": 0.00001
        //         },
        //         {
        //             "code": "r",
        //             "name": "藝術、娛樂及休閒服務業",
        //             "rate": 2.48
        //         },
        //         {
        //             "code": "s",
        //             "name": "其他服務業",
        //             "rate": 2.56667
        //         }
        //     ],
        //     "accumRate": 5.4402,
        //     "annuityRate": 0.987,
        //     "finalSalary": 45800,
        //     "inflation": 1.4,
        //     "interest": 0.77,
        //     "penConCap": 9000,
        //     "penRate": 6,
        //     "penYears": 35,
        //     "retireExpRate": 75,
        //     "socSecRate": 1.55,
        //     "SIRate1": {
        //         "name": "0%",
        //         "rate": 0.00001
        //     },
        //     "SIRate2": {
        //         "name": "2%",
        //         "rate": 2
        //     },
        //     "SIRate3": {
        //         "name": "6%",
        //         "rate": 6
        //     }
        // }
        // return of(data);
    }

    fillWPDForm(wpdForm: WpdForm) {
        return this.http
            .post<ApiResponse<boolean>>(environment.api_url, wpdForm, {
                headers: {
                    KeyId: environment.key.fillWPDForm,
                    Token: this.Token,
                }
            })
            .pipe(
                map(x => x.ReturnCode == 0)
            );
    }

    verifyKey(key: string) {
        return this.http
            .post<ApiResponse<boolean>>(environment.api_url, {
                key: key,
            }, {
                headers: {
                    KeyId: environment.key.verifyKey,
                }
            })
            .pipe(
                map(x => x.ReturnCode == 0)
            );
    }
}

interface ApiResponse<T> {
    ReturnCode: number,
    ReturnMessage: string,
    ReturnResult: T,
    ResponseDetails?: {
        responseCode: number,
        TrackingNumber: number,
    },
    ReasonCode?: {
        reasonCode: number,
        reasonMsg: string,
    },
}
